import axiosClient from "./axiosClient";

// Prépare le payload attendu par l'API blocage
const normalizeBlocagePayload = (data = {}) => {
  const { date_debut, date_fin, complet, atelier, zone } = data;

  const toBoolean = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return Boolean(value);
  };

  if (!date_debut || !date_fin || typeof complet === "undefined") {
    throw new Error(
      "date_debut, date_fin et complet sont requis pour créer ou mettre à jour un blocage"
    );
  }

  const toArrayIds = (value) =>
    Array.isArray(value)
      ? value.filter((v) => v !== undefined && v !== null && v !== "")
      : value || value === 0
      ? [value]
      : [];

  const completValue = toBoolean(complet);
  const atelierIds = toArrayIds(atelier);
  const zoneIds = toArrayIds(zone);

  if (!completValue && atelierIds.length === 0 && zoneIds.length === 0) {
    throw new Error(
      "Au moins un atelier ou une zone est requis quand complet est à false"
    );
  }

  return {
    date_debut,
    date_fin,
    complet: completValue,
    atelier: completValue ? [] : atelierIds,
    zone: completValue ? [] : zoneIds,
  };
};

const planningApi = {
  async getBlocages(params = {}) {
    const response = await axiosClient.get("/blocages/", { params });
    return response.data;
  },

  async getEvenements(params = {}) {
    const response = await axiosClient.get("/evenements/", { params });
    return response.data;
  },

  async getReservations(params = {}) {
    const response = await axiosClient.get("/reservations/", { params });
    return response.data;
  },

  async createBlocage(blocageData) {
    const payload = normalizeBlocagePayload(blocageData);
    const response = await axiosClient.post("/blocages/", payload);
    return response.data;
  },

  async updateBlocage(blocageId, blocageData) {
    const payload = normalizeBlocagePayload(blocageData);
    const response = await axiosClient.put(`/blocages/${blocageId}/`, payload);
    return response.data;
  },

  async deleteBlocage(blocageId) {
    await axiosClient.delete(`/blocages/${blocageId}/`);
  },
};

export const {
  getBlocages,
  getEvenements,
  getReservations,
  createBlocage,
  updateBlocage,
  deleteBlocage,
} = planningApi;
export default planningApi;
